<h1
  class="page-title"
  *ngIf="title"
  truncate
>
  {{ title | translate }}
</h1>
